import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import useIsomorphicLayoutEffect from '@utility/useIsomorphicLayoutEffect';
import cn from 'classnames';
import * as styles from './styles';
import ErrorIcon from '../../../static/images/icons/icon-info.svg';
import ErrorIconFilled from '../../../static/images/icons/icon-info-fill.svg';

const ToolTip = ({ text, children, className, as, showInfoIcon, bgWhite, ...rest }) => {
  const Wrapper = as;
  const ref = useRef();
  const [hovered, setIsHovered] = useState(false);
  const [isHoverable, setHoverable] = useState(false);
  useIsomorphicLayoutEffect(() => {
    setHoverable(!window.matchMedia('(hover: none)').matches);
  }, []);
  const clickOutside = (e) => {
    if (hovered && e.target !== ref.current) {
      setIsHovered(false);
    }
  };
  useEffect(() => {
    if (document !== 'undefined') {
      document.addEventListener('click', clickOutside);
      return () => {
        return document.removeEventListener('click', clickOutside);
      };
    }
  });
  return (
    <>
      <Wrapper className={`${styles.tooltip} ${className}`} {...rest}>
        <span
          onMouseEnter={() => isHoverable && setIsHovered(true)}
          onMouseLeave={() => isHoverable && setIsHovered(false)}
          onClick={() => !isHoverable && setIsHovered(true)}
        >
          {children}
        </span>
        <span
          className={cn(styles.tooltipText, {
            [styles.tooltipTextOpen]: hovered,
            [styles.bgWhite]: bgWhite && hovered
          })}
          dangerouslySetInnerHTML={text}
        />
        {(!isHoverable || showInfoIcon) && (
          <button
            onClick={() => !isHoverable && setIsHovered(true)}
            onMouseEnter={() => showInfoIcon && setIsHovered(true)}
            onMouseLeave={() => showInfoIcon && setIsHovered(false)}
            type="button"
            ref={ref}
            className="p-2"
            aria-label='Alert'
          >
            <img
              src={hovered ? ErrorIconFilled : ErrorIcon}
              alt="Alert icon"
              className='w-3 md:w-[10px]'
              width="12"
            />
          </button>
        )}
      </Wrapper>
    </>
  );
};

ToolTip.propTypes = {
  text: PropTypes.shape({ __html: PropTypes.string }),
  children: PropTypes.node.isRequired,
  as: PropTypes.string,
  className: PropTypes.string,
};

ToolTip.defaultProps = {
  text: { __html: '' },
  as: 'div',
  className: '',
};

export default ToolTip;
